import {doc} from '../../docs.js';
import {lazy} from '../lazy.js';
import {extractCode} from '../extract.js';
import {float, utils, extract} from '../utils.js';
import {gl} from '../struct.js';
import {hashCode} from 'utils/hashCode.js';

doc(
    "gl.length",
    {
        "vector":""
    },
    "Returns the gl expression that calculates length of vector",
    () => 1,
    {
        inlets: 1
    });

const gl_length = (object) => {
    object.needsHotReload = true;
    return lazy((val) => {
        let codes = extractCode(val);
        object.flash();
        return `length(${float(codes[0])})`;
    });
};

doc(
    "gl.sdRoundBox",
    {
        "position": "",
        "size": "",
        "cornerRadius":""
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 3
    });

const gl_sdRoundBox = (object, size, round) => {
    object.needsHotReload = true;
    return lazy((val) => {
        let codes = extractCode(val, size, round);
        object.flash();
        return `sdRoundBox(${float(codes[0])}, vec2(${float(codes[1])}), (${float(codes[2])}))`;
    }, size, round);
};

doc(
    "gl.sdRoundRect",
    {
        "position": "",
        "sizeVec": "",
        "cornerRadius":""
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 3
    });

const gl_sdRoundRect = (object, size, round) => {
    object.needsHotReload = true;
    return lazy((val) => {
        let codes = extractCode(val, size, round);
        object.flash();
        return `sdRoundBox(${float(codes[0])}, ${float(codes[1])}, (${float(codes[2])}))`;
    }, size, round);
};

doc(
    "gl.circle",
    {
        "position": "",
        "radius": "",
    },
    "Creates circle sdf for given radius and position",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });

const gl_circle = (object, radius) => {
    object.needsHotReload = true;
    return lazy((val) => {
        let codes = extractCode(val, radius);
        object.flash();
        return `length((gl_FragCoord.xy-vec2(width, height))/height - ${float(codes[0])}) - ${float(codes[1])}`;
    }, radius);
};

doc(
    "gl.sdfMerge",
    {
        "sdf": ""
    },
    "Merges sdfs given as arguments",
    () => 1,
    {
        isHot: true,
        inlets: x => x
    });

const gl_sdf_merge = (object, ...args) => {
    object.needsHotReload = true;
    return lazy((first) => {
        let _args = [first, ...args.filter(x => x() !== 0 && x() !== undefined).map(x => x())];
        let codes  = extractCode(... _args);
        let _code = merge(codes);
        object.flash();
        return merge(codes);
    }, ...args);
};

const merge = (codes) => {
    if (codes.length === 0) {
        return float(0);
    }
    let code = codes[0];
    if (codes.length === 1) {
        return float(code);
    }

    return `min(${float(code)}, ${merge(codes.slice(1))})`;
};

export const sdf_union = merge;

doc(
    "gl.between",
    {
        number: "",
        a:"",
        b:""
    },
    "Returns 1 if value is between a and b-- 0 otherwise",
    () => 1,
    {
        isHot: true,
        inlets: 3
    });
export const gl_between = (object, a,b) => {
    return lazy((x) => {
        let codes  = extractCode(x,a,b);
        return `(${float(codes[0])} >= ${float(codes[1])} && ${float(codes[0])} < ${float(codes[2])} ? 1.0 : 0.0)`;
    }, a, b);
};

export const sdf = {
    'gl.length': gl_length,
    'gl.between': gl_between,
    'gl.sdRoundBox': gl_sdRoundBox,
    'gl.sdRoundRect': gl_sdRoundRect,
    'gl.sdfMerge': gl_sdf_merge,
    'gl.circle': gl_circle
};
